import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { MTMFileDownloadService } from '../mtm-file-download/mtm-file-download.service';
import { VideoFile, VideoItem, ResolutionOption, TranscodeMetadata } from './video-annotation.interfaces';

export interface BuildVideoJsOptionsParams {
  file: VideoFile;
  item: VideoItem;
  autoPlayVideo: boolean;
  height: string;
  videoPreloadMethod: string;
  enableVideoAnnotation: boolean;
  width: string;
  miniPlayer: boolean;
  downloadControlId: string;
  downloadCallback: (controlId: string, quality?: string) => void;
  subtitlePlugin?: any;
}

@Injectable({ providedIn: 'root' })
export class VideoAnnotationConfigService {
  private readonly IGNORE_QUALITIES: string[] = ['_SMALL_211_121', '_SMALL_209_241', '_TINY_211_121', '_TINY_209_241', '_TINY', '_SMALL'];

  constructor(private readonly mtmFileDownloadService: MTMFileDownloadService) { }

  buildVideoJsOptions(params: BuildVideoJsOptionsParams): any {
    const { file } = params;
    const metadata = file.metadata;
    if (!metadata || JSON.parse(metadata).length === 0) {
      return null;
    }

    const videoMetaData = this.getVideoMetadata(file);

    const options: any = {
      aspectRatio: '4:3',
      autoplay: params.autoPlayVideo,
      fluid: true,
      playsinline: true,
      height: _.isNumber(params.height) ? parseInt(params.height as any, 10) : params.height,
      preload: params.videoPreloadMethod || (params.enableVideoAnnotation ? 'auto' : 'metadata'),
      width: parseInt(params.width as any, 10),
      controlBar: {
        customPlaybackRateMenu: {},
        playbackRateMenuButton: false,
        children: [
          'playToggle',
          'customPlaybackRateMenu',
          'volumePanel',
          'customControlSpacer',
          'currentTimeDisplay',
          'timeDivider',
          'durationDisplay',
          'customControlSpacer',
          'progressControl',
          'PictureInPictureToggle',
          'fullscreenToggle'
        ]
      },
      plugins: {
        vjsdownload: {
          controlId: params.downloadControlId,
          beforeElement: 'ResolutionSwitcher',
          textControl: 'Download',
          name: 'downloadButton',
          isDownloading: this.mtmFileDownloadService.isFileInDownload(params.downloadControlId),
          downloadCallback: params.downloadCallback,
          mediaQuality: (params.item?.transcodeMetadata || []).filter((m: TranscodeMetadata) => !this.IGNORE_QUALITIES.includes(m.quality)),
          originalMedia: {
            resolution: `${videoMetaData.width}x${videoMetaData.height}`,
            codec: videoMetaData.codecName
          }
        },
        videoJsResolutionSwitcher: {
          default: 'second-high',
          dynamicLabel: true,
        }
      },
      playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
    };

    if (params.miniPlayer) {
      options.plugins.threeDotMenu = true;
    }

    if (params.subtitlePlugin) {
      options.plugins.subtitle = params.subtitlePlugin;
    }

    return options;
  }

  private getVideoMetadata(file: VideoFile): any {
    if (file?.metadata) {
      return JSON.parse(file.metadata).filter((item: any) => item.codecType === 'VIDEO')[0] || {};
    }
    return {};
  }
}


